import queryString from 'query-string';
import { all, call, put, takeLatest } from 'redux-saga/effects';

import { acceptTerms as acceptTermsAction } from 'modules/auth/login/data/actions';
// TODO get rid of these sibling module reaches
import { loginWithToken } from 'modules/auth/login/data/sagas';

import API, {
  chatRegistrationDetails,
  registrationDetails,
} from 'services/api';
import authService from 'services/authService';

import { getPaperlessTerms } from 'store/session/sagas';

import history from 'utils/browserHistory';
import { setToken } from 'utils/token';

import { registration, types } from './actions';

function* acceptTerms(acceptedTerms) {
  try {
    yield all(
      acceptedTerms.map((terms) => call(authService.acceptTerms, terms)),
    );
    yield put(acceptTermsAction.success());
  } catch (error) {
    yield put(acceptTermsAction.error({ error }));
  }
}

export function* initRegistrationPage({ location }) {
  try {
    const key = queryString.parse(location.search).key;
    const isChat = queryString.parse(location.search).is_chat;
    yield call(getPaperlessTerms);
    return isChat
      ? yield call(chatRegistrationDetails, key)
      : yield call(registrationDetails, key);
  } catch (error) {
    //if invite is expired show error
    if (error.code == 'invite_expired') {
      throw error;
    }
    //otherwise it is likely that the invite has already been accepted so redirect use to login
    const next = queryString.parse(location.search).next;
    history.push(next ? `/login?next=${next}` : '/login');
  }
}

function* watchRegistration(action) {
  try {
    const { key, data, acceptedTerms } = action.payload;
    const { token } = yield call(API.auth.register, key, data);
    yield put(registration.success());

    // HACK: set token upfront to accept terms before login
    yield call(setToken, token);
    yield acceptTerms(acceptedTerms);

    yield call(loginWithToken, token);
  } catch (error) {
    yield put(registration.error(error));
  }
}

function* watchChatRegistration(action) {
  try {
    const { key, data } = action.payload;
    const { token } = yield call(API.auth.chatRegister, key, data);
    yield put(registration.success());
    yield call(setToken, token);
    const next = queryString.parse(window.location.search).next;
    const nextUrl = decodeURIComponent(next || '');
    yield call(loginWithToken, token, nextUrl);
  } catch (error) {
    yield put(registration.error(error));
  }
}

export default function* root() {
  yield takeLatest(types.REGISTRATION_REQUEST, watchRegistration);
  yield takeLatest(types.CHAT_REGISTRATION_REQUEST, watchChatRegistration);
}
